// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3OMvQ","modalForm":"UpgradeEpcsModal_modalForm__Cw6O3","modalFooter":"UpgradeEpcsModal_modalFooter__165qn"};